module.exports = __webpack_public_path__ + "img/authentication-hero.b1831cf1.svg";